import { Notify } from '~/components2/Notify';

export function notifyDownloadError() {
  Notify.error({
    title: '⚠️',
    message: 'There was an error during the download process. Please try again or contact support.',
  });
}
